/*
  Veda Product Card — variant switching for snippets/veda-product-card.liquid

  Adding to cart is NOT handled here. The card wraps the theme's own
  <product-form> element, so product-form.js does the ajax POST to
  routes.cart_add_url and renders cart-drawer / cart-notification exactly like
  every other add-to-cart form in the theme. This element only keeps the
  form's [name=id] input, the price block, the image and the button state in
  sync with whichever option combination is selected.
*/

if (!customElements.get('veda-product-card')) {
  customElements.define(
    'veda-product-card',
    class VedaProductCard extends HTMLElement {
      connectedCallback() {
        if (this.dataset.vpcReady === 'true') return;
        this.dataset.vpcReady = 'true';

        this.variants = this.parseVariants();
        if (!this.variants.length) return;

        this.inputs = Array.from(this.querySelectorAll('.vpc__swatch-input'));
        if (!this.inputs.length) return;

        this.variantIdInput = this.querySelector('.vpc__variant-id');
        this.submitButton = this.querySelector('.vpc__atc');
        this.submitText = this.querySelector('.vpc__atc-text');
        this.image = this.querySelector('.vpc__image');
        this.priceCurrent = this.querySelector('.vpc__price-current');
        this.priceCompare = this.querySelector('.vpc__price-compare');
        this.priceRule = this.querySelector('.vpc__price-rule');
        this.priceBadge = this.querySelector('.vpc__price-badge');

        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      parseVariants() {
        const node = this.querySelector('.vpc__variant-data');
        if (!node) return [];
        try {
          return JSON.parse(node.textContent) || [];
        } catch (e) {
          console.error('veda-product-card: bad variant JSON', e);
          return [];
        }
      }

      onChange(event) {
        if (!event.target.classList.contains('vpc__swatch-input')) return;
        this.updateVariant();
      }

      get selectedOptions() {
        const values = [];
        this.inputs.forEach((input) => {
          if (!input.checked) return;
          const position = parseInt(input.dataset.optionPosition, 10) || 1;
          values[position - 1] = input.value;
        });
        return values;
      }

      updateVariant() {
        const selected = this.selectedOptions;
        const variant = this.variants.find((candidate) =>
          candidate.options.every((value, index) => selected[index] === undefined || selected[index] === value)
        );

        this.updateFormState(variant);
        this.updatePrice(variant);
        this.updateImage(variant);
      }

      updateFormState(variant) {
        if (!this.variantIdInput || !this.submitButton) return;

        if (!variant) {
          this.variantIdInput.value = '';
          this.variantIdInput.disabled = true;
          this.submitButton.setAttribute('disabled', 'disabled');
          if (this.submitText) this.submitText.textContent = window.variantStrings.unavailable;
          return;
        }

        this.variantIdInput.value = variant.id;
        this.variantIdInput.disabled = !variant.available;

        if (variant.available) {
          this.submitButton.removeAttribute('disabled');
          if (this.submitText) this.submitText.textContent = window.variantStrings.addToCart;
        } else {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (this.submitText) this.submitText.textContent = window.variantStrings.soldOut;
        }
      }

      updatePrice(variant) {
        if (!variant || !this.priceCurrent) return;

        this.priceCurrent.textContent = variant.price;

        if (this.priceCompare) {
          this.priceCompare.textContent = variant.compare_at_price || '';
          this.priceCompare.toggleAttribute('hidden', !variant.on_sale);
        }
        if (this.priceRule) this.priceRule.toggleAttribute('hidden', !variant.on_sale);
        if (this.priceBadge) {
          this.priceBadge.textContent = variant.discount + '% OFF';
          this.priceBadge.toggleAttribute('hidden', !variant.on_sale);
        }
      }

      updateImage(variant) {
        if (!variant || !variant.image || !this.image) return;
        if (this.image.getAttribute('src') === variant.image) return;

        this.image.setAttribute('src', variant.image);
        this.image.removeAttribute('srcset');
      }
    }
  );
}
